import { CEPlanWorkAssociationAttributesBase } from './ce-plan-work-association-attributes-base'


export class CEPlanWorkAssociationAttributes extends CEPlanWorkAssociationAttributesBase {

}